export default {"src":"/_next/static/media/Animation-1715778919011.6c3c1429.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};